/* ==========================================================================
   ALIENTO PERRO — fecha de despacho con formato "Vie 31/07".

   Por qué existe este archivo: el bloque "Estimated shipping" del theme trae
   7 formatos fijos y ninguno da "Vie 31/07" (el más parecido es
   "Monday, 01. 02.", con puntos). Así que reescribimos la línea nosotros.

   Además calcula en DÍAS HÁBILES: si la fecha cae sábado o domingo, pasa al
   lunes. El cálculo del theme no distingue.

   OJO: mientras este archivo esté activo, el dropdown "Date format" del
   editor no tiene efecto sobre esta línea. El formato se cambia acá.
   ========================================================================== */

(function () {
  'use strict';

  var SEL = 'dynamic-dates [data-dynamic-date]';
  var DIAS_FALLBACK = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

  /* Suma días hábiles salteando sábados y domingos. */
  function diaHabil(base, dias) {
    var d = new Date(base.getTime());
    var n = 0;
    while (n < dias) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n++;
    }
    return d;
  }

  /* "Vie 31/07" — armado a mano y no con el patrón del locale, porque
     es-AR devuelve "vie 31-07" y es devuelve "vie, 31/07" según el ICU
     del navegador. Del locale usamos solo el nombre abreviado del día. */
  function formatear(d) {
    var dia;
    try {
      dia = new Intl.DateTimeFormat('es', { weekday: 'short' })
        .format(d)
        .replace(/\./g, '');
    } catch (e) {
      dia = DIAS_FALLBACK[d.getDay()];
    }
    dia = dia.charAt(0).toUpperCase() + dia.slice(1);

    var dd = String(d.getDate()).padStart(2, '0');
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    return dia + ' ' + dd + '/' + mm;
  }

  function pintar(el) {
    var plantilla = el.getAttribute('data-text');
    if (!plantilla) return;

    var min = parseInt(el.getAttribute('data-min-days'), 10);
    var max = parseInt(el.getAttribute('data-max-days'), 10);
    if (isNaN(min)) min = 1;
    if (isNaN(max)) max = min;

    var hoy = new Date();
    var desde = formatear(diaHabil(hoy, min));
    var hasta = formatear(diaHabil(hoy, max));

    /* Si el texto ya tiene la fecha que corresponde, no tocamos nada.
       Esto evita el bucle infinito con el MutationObserver de abajo. */
    if (el.textContent.indexOf(desde) !== -1) return;

    el.innerHTML = plantilla
      .replace(/\[start_date\]/g, desde)
      .replace(/\[end_date\]/g, hasta);
  }

  function aplicar() {
    var nodos = document.querySelectorAll(SEL);
    for (var i = 0; i < nodos.length; i++) pintar(nodos[i]);
  }

  function iniciar() {
    aplicar();

    /* El theme escribe su propia versión cuando el custom element se conecta,
       que puede pasar después que nosotros. Si nos pisa, reaplicamos. */
    if (typeof MutationObserver === 'function') {
      var obs = new MutationObserver(aplicar);
      var nodos = document.querySelectorAll(SEL);
      for (var i = 0; i < nodos.length; i++) {
        obs.observe(nodos[i], { childList: true, characterData: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* Al editar en el editor de Shopify la sección se vuelve a renderizar. */
  document.addEventListener('shopify:section:load', iniciar);
})();
